module.exports = __webpack_public_path__ + "static/media/hic-logo-white.b59b2732.png";